import { createFileRoute, Outlet } from "@tanstack/react-router";
import { SiteShell } from "@/components/site/SiteShell";

export const Route = createFileRoute("/especialidades")({
  component: EspecialidadesLayout,
});

function EspecialidadesLayout() {
  return (
    <SiteShell>
      <Outlet />
    </SiteShell>
  );
}
